import { useState } from "react";
import { TableCell, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronRight } from "lucide-react";
import { ReportProps } from "../common.props";
import { formatNumber } from "@/lib/currency.utils";

function CategoryBreakdownRow({
  cat,
  displayCurrency,
  convert
}: {
  cat: CategoryBreakdown;
} & ReportProps) {
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <TableRow>
        <TableCell>
          <Button
            variant="ghost"
            size="sm"
            className="h-6 w-6 p-0 mr-2"
            onClick={() => setExpanded((v) => !v)}
            aria-label={
              expanded
                ? `Collapse ${cat.categoryName}`
                : `Expand ${cat.categoryName}`
            }
            disabled={cat.subCategories.length === 0}>
            {cat.subCategories.length > 0 ? (
              expanded ? (
                <ChevronDown className="h-4 w-4" />
              ) : (
                <ChevronRight className="h-4 w-4" />
              )
            ) : null}
          </Button>
          {cat.categoryName}
        </TableCell>
        <TableCell>{displayCurrency}</TableCell>

        <TableCell className="text-right">{formatNumber(cat.total)}</TableCell>
        <TableCell className="text-right">
          {cat.percentage.toFixed(1)}%
        </TableCell>
      </TableRow>
      {expanded && cat.subCategories.map((sub) => {
        const formattedSubCategoryTotalValue = formatNumber(convert(sub.total, sub.currency, displayCurrency));

        return (
          <TableRow key={sub.subCategoryId} className="bg-muted/30">
            <TableCell className="pl-10">{sub.subCategoryName}</TableCell>
            <TableCell className="pl-10">{displayCurrency}</TableCell>
            <TableCell className="text-right">{formattedSubCategoryTotalValue}</TableCell>
            <TableCell className="text-right">
              {sub.percentage.toFixed(1)}%
            </TableCell>
          </TableRow>
        );
      })}
    </>
  );
}

export default CategoryBreakdownRow;
